/* eslint-disable @typescript-eslint/no-var-requires */

// @ts-expect-error untyped

export const UISortableList = $hasDep('ui-addon-draggable', '3') ? require('ui-addon-draggable/components/unconnected/UISortableList').default : require('./internal/SortableList.v2').default;

// Temporary export for backwards compat
export { UISortableList as SortableList };
export const UIDragListHandle = $hasDep('ui-addon-draggable', '3') ? require('ui-addon-draggable/draggable/UIDragListHandle').default : require('./internal/DragListHandle.v2').default;

/**
 * foundations-components compatible drag list handle
 */
export const DragListHandle = $hasDep('ui-addon-draggable', '3') ? require('foundations-components/transitional/components/DragHandle').DragHandle : $hasDep('ui-addon-draggable', '2') ? require('ui-addon-draggable/draggable/DragListHandle').default : require('ui-addon-draggable/draggable/DragListHandle').DragListHandle;